const s = {}

// ── Existing code-keyed strings (backward compat) ────────────────────────────
s.no_permission = 'Ваш обліковий запис не має прав для перегляду цієї сторінки.'
s.share_but_no_comments_warning =
  "Ця розмова не має коментарів. Рекомендуємо додати кілька коментарів перед запрошенням учасників. Перейдіть до 'Налаштування', потім 'Початкові коментарі'."
s.share_but_no_visible_comments_warning =
  'Ця розмова не має видимих коментарів. Рекомендуємо додати або відмодерувати коментарі перед запрошенням учасників.'

// ── InteriorHeader ────────────────────────────────────────────────────────────
s['sign out'] = 'вийти'

// ── Conversations page ────────────────────────────────────────────────────────
s['All Conversations'] = 'Всі розмови'
s['My Conversations'] = 'Мої розмови'
s['Create new conversation'] = 'Створити нову розмову'
s['Loading conversations...'] = 'Завантаження розмов...'
s['Error loading conversations'] = 'Помилка завантаження розмов'

// Table headers
s.col_topic = 'Тема'
s.col_participants = 'Учасники'
s.col_comments = 'Коментарі'
s.col_updated = 'Оновлено'
s.col_created = 'Створено'
s.col_owner_email = 'Email власника'
s.col_active = 'Активна'

// Mobile labels
s.label_topic = 'Тема: '
s.label_participants = 'Учасники: '
s.label_comments = 'Коментарі: '
s.label_updated = 'Оновлено: '
s.label_created = 'Створено: '
s.label_owner = 'Власник: '
s.label_active = 'Активна: '

// Filters
s.filter_owner_email = 'Email власника містить...'
s.filter_all_statuses = 'Усі статуси'
s.filter_active = 'Активна'
s.filter_inactive = 'Неактивна'
s.filter_min_comments = 'Мін. коментарів'
s.filter_min_participants = 'Мін. учасників'
s.filter_updated_days = 'Оновлено за останні N днів'
s.filter_created_days = 'Створено за останні N днів'
s.sort_updated = 'Сорт: Оновлено'
s.sort_created = 'Сорт: Створено'
s.sort_participants = 'Сорт: Учасники'
s.sort_comments = 'Сорт: Коментарі'
s.sort_desc = 'Спадання'
s.sort_asc = 'Зростання'
s.btn_apply = 'Застосувати'

// Interstitial (можливості аналітики CID — вже включені)
s.polis2_heading = 'Розширена AI-аналітика — вже включена'
s.polis2_intro =
  'Ваша інсталяція Polis від Центру розвитку інновацій (CID) включає повний набір аналітики, демографії та AI-звітності — безкоштовно для громад.'
s.polis2_stats_heading = 'Кластери думок і теми'
s.polis2_stats_text =
  'Групи думок, репрезентативні твердження, зони консенсусу та інтерактивна тематична карта — бачте, де громада згодна, а де розходиться.'
s.polis2_ai_heading = 'Демографія, UTM і AI-звіти'
s.polis2_ai_text =
  'Вхідний профіль учасників (стать, вік, статус), аналітика каналів залучення (UTM) та наративні AI-звіти у форматі Word — з поясненнями й діаграмами українською.'
s.polis2_features_heading = 'Що включено:'
s.polis2_feature_summaries = 'Наративні AI-звіти (Word / docx)'
s.polis2_feature_topics = 'Тематична карта та кластери думок'
s.polis2_feature_consensus = 'Демографічний профіль учасників'
s.polis2_feature_divisive = 'UTM-аналітика каналів залучення'
s.polis2_cta = 'Дізнайтеся більше про платформу:'
s.polis2_upgrade = 'polis.cid.center'
s.btn_maybe_later = 'Пропустити'
s.btn_create_conversation = 'Створити розмову'

// Вибір демографії при створенні розмови
s.create_demographics_label = 'Увімкнути демографічне опитування учасників'
s.create_demographics_hint =
  'Коротке вхідне опитування (стать, вік, соціальний статус, стан роботи) перед голосуванням. Це можна змінити пізніше в «Налаштуваннях».'

// Сторінка налаштувань розмови (Configure)
s.cfg_configure = 'Налаштування'
s.cfg_saving = 'Збереження…'
s.cfg_uptodate = 'Збережено'
s.cfg_error_saving = 'Помилка збереження'
s.cfg_topic = 'Тема'
s.cfg_description = 'Опис'
s.cfg_seed_comments = 'Початкові твердження'
s.cfg_customize_ui = 'Налаштування інтерфейсу'
s.cfg_is_active_desc =
  'Розмову відкрито. Якщо зняти позначку, вимкнуться і голосування, і коментування.'
s.cfg_vis_desc = 'Учасники бачать візуалізацію'
s.cfg_write_desc = 'Учасники можуть надсилати коментарі'
s.cfg_help_desc = 'Показувати пояснювальний текст над голосуванням і візуалізацією'
s.cfg_subscribe_desc =
  'Пропонувати учасникам підписатися на оновлення. Підказка показується після того, як учасник проголосував за всі наявні твердження. Якщо ввімкнено, учасники можуть за бажанням вказати email, щоб отримувати сповіщення про нові твердження для голосування.'
s.cfg_strict_mod_desc = 'Коментарі не показуються без схвалення модератора'
s.cfg_treevite_desc =
  '[ЕКСПЕРИМЕНТАЛЬНА ФУНКЦІЯ] Увімкнути дерево запрошень. Ніхто не може брати участь без запрошення. Запрошення керуються хвилями.'
s.cfg_importance_desc =
  '[ЕКСПЕРИМЕНТАЛЬНА ФУНКЦІЯ] Учасники бачать позначку «Це твердження важливе».'
s.cfg_demographics_desc =
  '[ЕКСПЕРИМЕНТАЛЬНА ФУНКЦІЯ] Учасники проходять коротке вхідне опитування (стать, вік, соціальний статус, стан роботи) перед голосуванням. Відповіді привʼязуються до UTM-міток і доступні у звітах.'
s.cfg_topics_desc =
  '[ЕКСПЕРИМЕНТАЛЬНА ФУНКЦІЯ] Учасники можуть обирати пріоритетні теми. (Потребує розширеної звітності.)'

// Конструктор UTM-посилань (вкладка «Поширення»)
s.utm_builder_heading = 'UTM-посилання для поширення'
s.utm_builder_hint =
  'Побудуйте посилання з UTM-мітками для кожного каналу. Джерело обовʼязкове, решта — за бажанням. Збережені посилання зберігаються в цьому браузері.'
s.utm_source_label = 'Джерело (utm_source) *'
s.utm_medium_label = 'Канал (utm_medium)'
s.utm_campaign_label = 'Кампанія (utm_campaign)'
s.utm_term_label = 'Ключове слово (utm_term)'
s.utm_content_label = 'Контент (utm_content)'
s.utm_generated_link = 'Згенероване посилання'
s.utm_copy = 'Копіювати'
s.utm_copied = 'Скопійовано!'
s.utm_save = 'Зберегти в перелік'
s.utm_saved_heading = 'Збережені посилання'
s.utm_remove = 'Видалити'
s.utm_empty = 'Поки немає збережених посилань.'

// ── Conversation card (Conversation.js) ──────────────────────────────────────
s.participants_count = 'учасників'
s.embedded_on = 'Вбудовано на'

// ── Conversation admin nav tabs ───────────────────────────────────────────────
s.nav_all = 'Всі'
s.nav_configure = 'Налаштування'
s.nav_distribute = 'Поширення'
s.nav_moderate = 'Модерація'
s.nav_monitor = 'Моніторинг'
s.nav_reports = 'Звіти'
s.nav_invite_tree = 'Дерево запрошень'
s.nav_invite_codes = 'Коди запрошень'
s.nav_participants = 'Учасники'
s.nav_import = 'Імпорт'



// ── Monitor / stats tab ──
s.mon_monitor = "Моніторинг"
s.mon_loading = "Завантаження..."
s.mon_participants_voted = "учасників проголосувало"
s.mon_votes_were_cast = "голосів віддано"
s.mon_votes_per_participant_average = "голосів на учасника в середньому"
s.mon_commented = "залишили коментарі"
s.mon_comments_submitted = "коментарів надіслано"
s.mon_utm_sources = "Джерела UTM"
s.mon_download_csv = "Завантажити CSV"
s.mon_source = "Джерело"
s.mon_medium = "Канал"
s.mon_campaign = "Кампанія"
s.mon_participants = "Учасники"
s.mon_dim_gender = "Стать"
s.mon_dim_age_group = "Вікова група"
s.mon_dim_social_status = "Соціальний статус"
s.mon_dim_work_situation = "Зайнятість"
s.mon_demographics = "Демографія"
s.mon_voters_over_time = "Голосування в часі (за моментом першого голосу)"
s.mon_commenters_over_time = "Коментування в часі (за моментом першого коментаря)"

// ── Configure & moderation residuals ──
s.cfg2_conversation_is_open = "Розмова відкрита"
s.cfg2_visualization = "Візуалізація"
s.cfg2_comment_form = "Форма коментаря"
s.cfg2_help_text = "Довідковий текст"
s.cfg2_subscribe_prompt = "Пропонувати учасникам підписатися на оновлення"
s.cfg2_enable_invite_tree = "Увімкнути дерево запрошень"
s.cfg2_importance_enabled = "Оцінювання важливості увімкнено"
s.cfg2_demographics_survey = "Демографічне опитування"
s.cfg2_topics_enabled = "Теми увімкнено"
s.cfg2_loading_accepted_comments = "Завантаження прийнятих коментарів..."
s.cfg2_comment_flagged_automod = "Коментар позначено API автоматичної модерації Polis. Коментар не показується учасникам. Прийміть, щоб перевизначити."
s.cfg2_metadata = "метадані"

// ── Reports tab ──
s.rep_showing_moderated_only = "Показано лише модеровані коментарі"
s.rep_showing_moderated_unmoderated = "Показано модеровані та немодеровані коментарі"
s.rep_showing_all_comments = "Показано всі коментарі, зокрема відхилені модерацією"
s.rep_minutes_ago = "хвилин тому"
s.rep_hours_ago = "годин тому"
s.rep_days_ago = "днів тому"
s.rep_loading_reports = "Завантаження звітів…"
s.rep_reports = "Звіти"
s.rep_select_comments_visible = "Виберіть, які коментарі будуть видимі в цьому звіті:"
s.rep_include_all_comments = "Включити всі коментарі"
s.rep_include_all_except_rejections = "Включити всі коментарі, крім відхилених модерацією"
s.rep_include_accepted_only = "Включити лише погоджені модератором коментарі"
s.rep_create_report_url = "Створити посилання на звіт"
s.rep_modified = "Змінено"
s.rep_report_id = "ID звіту"
s.rep_report_urls = "Посилання на звіт"
s.rep_standard_report = "Стандартний звіт"
s.rep_data_export = "Експорт даних"
s.rep_topic = "Тема"
s.rep_topics_viz = "Візуалізація тем"
s.rep_topic_stats = "Статистика тем"
s.rep_topic_map_narrative = "Наратив карти тем"
s.rep_analysis_insights = "Аналіз та інсайти"
s.rep_delphi_discover_more = "Відкрийте більше з Delphi — розширений аналіз даних та ШІ"

// ── Topics moderation tab ──
s.top_loading = "Завантаження..."
s.top_topic_moderation = "Модерація тем"
s.top_topics_tree = "Дерево тем"
s.top_proximity_map = "Карта близькості"
s.top_statistics = "Статистика"
s.top_moderation_not_enabled = "Модерацію тем не увімкнено для цієї розмови."
s.top_see = "Див."
s.top_for_more_information = "для докладнішої інформації."
s.top_topic_moderation_statistics = "Статистика модерації тем"
s.top_failed_load_statistics = "Не вдалося завантажити статистику"
s.top_network_error_statistics = "Помилка мережі під час завантаження статистики"
s.top_loading_statistics = "Завантаження статистики..."
s.top_error = "Помилка"
s.top_no_statistics_available = "Статистика недоступна."
s.top_total_topics = "Усього тем"
s.top_pending = "Очікує"
s.top_accepted = "Прийнято"
s.top_rejected = "Відхилено"
s.top_completion_rate = "Рівень завершення"
s.top_moderation_progress = "Прогрес модерації"
s.top_overall_progress = "Загальний прогрес"
s.top_complete = "Завершено"
s.top_no_topics_generated_yet = "Для цієї розмови ще не згенеровано жодної теми."
s.top_run_delphi_to_generate = "Запустіть конвеєр Delphi, щоб згенерувати теми для модерації."
s.top_failed_load_comments = "Не вдалося завантажити коментарі"
s.top_network_error_comments = "Помилка мережі під час завантаження коментарів"
s.top_meta = "Мета"
s.top_id = "ID"
s.top_cluster = "Кластер"
s.top_layer = "Шар"
s.top_position = "Позиція"
s.top_loading_comments = "Завантаження коментарів..."
s.top_retry = "Повторити"
s.top_back_to_topics = "Назад до тем"
s.top_topic = "Тема"
s.top_comments = "коментарів"
s.top_select_all = "Вибрати всі"
s.top_selected = "вибрано"
s.top_accept_selected = "Прийняти вибрані"
s.top_reject_selected = "Відхилити вибрані"
s.top_no_comments_found = "Для цієї теми не знайдено коментарів."
s.top_failed_load_topics = "Не вдалося завантажити теми"
s.top_network_error_topics = "Помилка мережі під час завантаження тем"
s.top_status = "Статус"
s.top_unnamed_topic = "Тема без назви"
s.top_no_comments = "Немає коментарів"
s.top_accept = "Прийняти"
s.top_reject = "Відхилити"
s.top_view_comments = "Переглянути коментарі"
s.top_model = "Модель"
s.top_unknown = "Невідомо"
s.top_created = "Створено"
s.top_moderated_by = "Модерував"
s.top_topics_lower = "тем"
s.top_loading_topics = "Завантаження тем..."
s.top_no_topics_available = "Немає доступних тем для цієї розмови."
s.top_topics_generated_by_delphi = "Теми генеруються конвеєром Delphi. Переконайтеся, що конвеєр було запущено для цієї розмови."
s.top_view_layer = "Переглянути шар"
s.top_all_layers = "Усі шари"
s.top_no_coordinate_data = "Немає доступних координатних даних"
s.top_comment = "Коментар"
s.top_umap_dimension_1 = "Вимір UMAP 1"
s.top_umap_dimension_2 = "Вимір UMAP 2"
s.top_failed_load_proximity = "Не вдалося завантажити дані близькості"
s.top_network_error_proximity = "Помилка мережі під час завантаження даних близькості"
s.top_loading_proximity = "Завантаження візуалізації близькості..."
s.top_proximity_visualization = "Візуалізація близькості"
s.top_proximity_description = "Ця візуалізація показує коментарі, розташовані за семантичною подібністю за допомогою координат UMAP. Коментарі, розташовані ближче, є більш семантично подібними."
s.top_hover_hint = "Наведіть курсор на точки, щоб побачити деталі коментаря. Точки згруповано за семантичними кластерами."
s.top_no_proximity_data = "Немає доступних даних близькості для цього шару."

// ── Distribute / invites / participants ──
s.dist_failed_load_invite_codes = "Не вдалося завантажити коди запрошень"
s.dist_status_unused = "Невикористаний"
s.dist_status_used = "Використаний"
s.dist_status_revoked = "Відкликаний"
s.dist_status_expired = "Прострочений"
s.dist_status = "Статус"
s.dist_failed_download_csv = "Не вдалося завантажити CSV"
s.dist_invite_codes_heading = "Коди запрошень"
s.dist_invite_tree_not_enabled = "«Дерево запрошень» не увімкнено. Щоб скористатися цією функцією, увімкніть «Дерево запрошень» у параметрах налаштування розмови."
s.dist_invite_codes_owner_desc = "Це коди запрошень для власника цієї розмови."
s.dist_preparing = "Підготовка…"
s.dist_download_csv = "Завантажити CSV"
s.dist_filters = "Фільтри"
s.dist_wave = "Хвиля"
s.dist_all_waves = "Усі хвилі"
s.dist_all_statuses = "Усі статуси"
s.dist_clear_filters = "Очистити фільтри"
s.dist_found = "Знайдено"
s.dist_invite_codes_lc = "кодів запрошень"
s.dist_col_code = "Код"
s.dist_col_used_at = "Використано"
s.dist_na = "Н/Д"
s.dist_no_invite_codes_found = "Кодів запрошень не знайдено. Створіть хвилі в розділі «Дерево запрошень», щоб згенерувати коди."
s.dist_failed_load_waves = "Не вдалося завантажити хвилі"
s.dist_failed_create_wave = "Не вдалося створити хвилю"
s.dist_invite_tree_heading = "Дерево запрошень"
s.dist_invite_only_desc = "Ця розмова доступна лише за запрошенням. Щоб голосувати чи коментувати, учасники повинні ввести дійсний код запрошення."
s.dist_waves = "Хвилі"
s.dist_parent = "батьківська"
s.dist_owner = "власник"
s.dist_size = "розмір"
s.dist_no_waves_yet = "Хвиль поки немає. Створіть першу хвилю нижче."
s.dist_create_next_wave = "Створити наступну хвилю"
s.dist_invites_per_user_desc = "Запрошень на користувача (надається кожному учаснику батьківської хвилі)"
s.dist_owner_invites_desc = "Запрошення власника (додаткові запрошення, які ви розподіляєте в цій хвилі)"
s.dist_parent_wave_desc = "Батьківська хвиля (необовʼязкове перевизначення). За замовчуванням — остання наявна хвиля; використайте 0 для кореневої."
s.dist_latest_default = "Остання (за замовчуванням)"
s.dist_root_0 = "Коренева (0)"
s.dist_creating = "Створення…"
s.dist_create_wave = "Створити хвилю"
s.dist_created_wave = "Створено хвилю"
s.dist_invites_created = "Створено запрошень"
s.dist_embedded_on = "Вбудовано на:"
s.dist_distribute = "Розповсюдження"
s.dist_share = "Поширення"
s.dist_embed = "Вбудовування"
s.dist_embed_single_conversation = "Цей код вбудовування можна використати лише для вбудовування однієї розмови."
s.dist_integrate_entire_site = "Я хочу інтегрувати pol.is на всьому своєму сайті."
s.dist_failed_load_xids = "Не вдалося завантажити XID"
s.dist_participant_management = "Керування учасниками"
s.dist_manage_participants_for = "Керуйте учасниками розмови"
s.dist_xid_required_to_vote = "XID обовʼязковий для голосування"
s.dist_xid_required_because_allow_list = "Обовʼязково, оскільки увімкнено список дозволених XID."
s.dist_use_xid_allow_list = "Використовувати список дозволених XID"
s.dist_xids_in_use = "Використовувані XID"
s.dist_xids_allowed = "Дозволені XID"
s.dist_no_xids_found = "Для цієї розмови XID не знайдено."
s.dist_download_xid_csv = "ЗАВАНТАЖИТИ XID CSV"
s.dist_loading_conversation_uuid = "Завантаження UUID розмови для завантаження XID..."
s.dist_could_not_load_conversation_uuid = "Не вдалося завантажити UUID розмови для завантаження XID"
s.dist_xid_csv_download = "завантаження xid csv"
s.dist_no_conversation_uuid_available = "Немає доступного UUID розмови для завантаження XID"
s.dist_what_is_an_xid = "ЩО ТАКЕ XID? РОЗПОЧНІТЬ РОБОТУ З ІДЕНТИФІКАЦІЄЮ УЧАСНИКІВ!"
s.dist_embed_code_loginless_param = "Параметр коду вбудовування, що дозволяє участь без входу для відомих користувачів"
s.dist_file_content_not_text = "Вміст файлу не є текстом"
s.dist_parsing_failed = "Помилка розбору: очікувався рядковий результат"
s.dist_error_reading_file = "Помилка читання файлу"
s.dist_enter_at_least_one_xid = "Введіть принаймні один XID"
s.dist_upload_xids = "Завантажити XID"
s.dist_upload_xids_desc = "Завантажте файл або вставте список XID для дозволу. Підтримуються файли CSV (із заголовками або без) і текстові файли (по одному XID на рядок)."
s.dist_processing_file = "Обробка файлу..."
s.dist_drop_file_here = "Перетягніть файл сюди"
s.dist_click_to_browse = "Натисніть, щоб вибрати, або перетягніть файл сюди"
s.dist_supports_csv_text = "Підтримуються файли CSV і текстові файли"
s.dist_allowed_xids = "Дозволені XID"
s.dist_paste_xids_placeholder = "Вставте XID сюди, по одному на рядок, або завантажте файл вище"
s.dist_replace_all_existing_xids = "Замінити всі наявні XID"
s.dist_cancel = "Скасувати"



// ── Main nav (MainLayout) ──
s.nav_conversations = "Розмови"
s.nav_integrate = "Інтеграція"
s.nav_account = "Обліковий запис"

// ── Moderation & pagination ──
s.mod_moderate = "Модерація"
s.mod_unmoderated = "Немодеровані"
s.mod_accepted = "Прийняті"
s.mod_rejected = "Відхилені"
s.mod_accept = "прийняти"
s.mod_reject = "відхилити"
s.mod_loading_unmoderated = "Завантаження немодерованих коментарів..."
s.mod_loading_accepted = "Завантаження прийнятих коментарів..."
s.mod_loading_rejected = "Завантаження відхилених коментарів..."
s.mod_showing = "Показано"
s.mod_of = "з"
s.mod_items = "елементів"
s.mod_first = "Перша"
s.mod_previous = "Попередня"
s.mod_next = "Наступна"
s.mod_last = "Остання"
s.mod_page = "Сторінка"

// ── Account / Integrate / import pages ──
s.pg_account = "Обліковий запис"
s.pg_hi = "Привіт"
s.pg_account_profile = "Профіль"
s.pg_account_name = "Ім'я"
s.pg_account_email = "Пошта"
s.pg_account_position = "Посада"
s.pg_account_phone = "Телефон"
s.pg_account_org = "Організація"
s.pg_account_org_name = "Назва організації"
s.pg_account_org_description = "Опис"
s.pg_account_org_logo = "Логотип"
s.pg_account_org_logo_url = "або вставте URL"
s.pg_account_logo_uploading = "Завантаження…"
s.pg_account_logo_too_large = "Файл завеликий (макс. 500 КБ)"
s.pg_account_logo_error = "Помилка завантаження лого"
s.pg_account_org_contact_email = "Контактна пошта"
s.pg_account_org_contact_phone = "Контактний телефон"
s.pg_account_save = "Зберегти"
s.pg_account_saving = "Збереження…"
s.pg_account_saved = "Збережено"
s.pg_account_save_error = "Помилка збереження"
s.pg_account_members = "Учасники організації"
s.pg_account_members_empty = "Поки немає учасників"
s.pg_account_invite_email = "Запросити за поштою"
s.pg_account_invite = "Запросити"
s.pg_account_inviting = "Надсилання…"
s.pg_account_invite_sent = "Запрошення надіслано"
s.pg_account_invite_error = "Помилка запрошення"
s.pg_account_invite_bad_email = "Невірна адреса пошти"
s.pg_account_pending_invites = "Очікують прийняття"
s.pg_account_invite_accept = "Приєднатися до організації"
s.pg_account_invite_accepting = "Приєднання…"
s.pg_account_invite_accepted = "Ви приєдналися до організації"
s.pg_account_invite_accept_error = "Не вдалося прийняти запрошення"
s.pg_integrate = "Інтеграція"
s.pg_integrate_intro = "Скопіюйте та вставте цей код у шаблон вашої системи керування контентом. Кожна сторінка (стаття, допис) потребує унікального рядка в полі «PAGE_ID». Він має бути незмінним у часі та унікальним для кожної з ваших сторінок (наприклад, заголовок статті)."
s.pg_integrate_li_create = "Коли цей код вбудовування завантажується на вашому сайті, він або створює нову розмову (якщо жодну ще не пов’язано з рядком, переданим у PAGE_ID), або завантажує наявну розмову."
s.pg_integrate_li_track = "Цей код вбудовування відстежує, які розмови належать яким сторінкам, за допомогою HTML-атрибута data-page_id."
s.pg_integrate_li_replace = "Просто замініть «PAGE_ID» вручну або у своїх шаблонах, щоб створювати нові розмови та завантажувати наявні у потрібному місці."
s.pg_file_too_big = "Файл завеликий! Максимальний розмір — 50 МБ."
s.pg_import = "Імпорт"
s.pg_import_success = "Ваше завантаження пройшло успішно. Ви отримаєте електронний лист після завершення завдання."
s.pg_import_desc = "Імпортуйте зовнішні дані розмови (коментарі та голоси) із зовнішніх джерел для показників звітності. Ця функція потребує завантаження двох файлів CSV: одного з коментарями, іншого з голосами. Спочатку потрібно завантажити коментарі. Після успішного завдання імпорту ви отримаєте електронний лист із повідомленням, що дані готові."
s.pg_import_comments = "Імпорт коментарів"
s.pg_upload_votes_csv_heading = "Завантажте CSV із голосами. Поле comment_id МАЄ збігатися з полем original_id у CSV коментарів. Обмеження розміру 50 МБ"
s.pg_csv_format = "Формат CSV:"
s.pg_vote_value_pattern = "vote_value МАЄ відповідати шаблону: 1 = згода, -1 = незгода, 0 = нейтрально/пропуск"
s.pg_upload_votes = "Завантажити голоси"

// ── XID explanation prose ──
s.xid_sometimes_the = "Іноді "
s.xid_of_a = " певної "
s.xid_has_existing_linkage = " вже має певний зв'язок з особистістю своїх "
s.xid_email_campaign_login_wall = ", тобто вони проводять розсилку електронною поштою або люди беруть участь із-за стіни авторизації, де вбудовано розмову"
s.xid_a_note_using = "Примітка: використання "
s.xid_assumes_that_the = " передбачає, що "
s.xid_has_the_token_different_from = " має токен; це відрізняється від "
s.xid_creating_single_use_urls = "створення одноразових посилань"
s.xid_works_in_embedded_case = " працює у випадку вбудовування, тобто "
s.xid_has_added_the = " додав "
s.xid_embed_code_label = "код вбудовування"
s.xid_to_page_on_web_property = " на сторінку власного вебресурсу"
s.xid_once_the = "Щойно "
s.xid_embedded_third_party_add_attribute = " вбудовано на сторонню вебсторінку, ця сторінка може будь-яким способом — наприклад, через JavaScript або шаблонізацію — додати атрибут даних "
s.xid_the_value_prefix = "Значення "
s.xid_value_available_on_record = " для кожного учасника буде доступне в записі участі в розділі "
s.xid_export_label = "експорт"
s.xid_example = "Приклад"
s.xid_common_workflow_for_using = "Поширений сценарій використання "
s.xid_involves_table_demographic = " передбачає таблицю демографічних даних, наданих провайдером опитувань"
s.xid_sent_email_invited = " отримують електронний лист із запрошенням узяти участь"
s.xid_then_when_the = "Потім, коли "
s.xid_clicks_through_custom_url = " переходить за посиланням з листа на власну URL-адресу, спеціальний JavaScript, написаний тим, хто керує стороннім вебсайтом, на якому вбудовано polis, отримує токен з URL-адреси й додає його до"
s.xid_usage = "Використання: "
s.xid_or_comma = " або "
s.xid_or_less_anonymously = " або, менш анонімно й не рекомендовано, "


// ── Seed comments / XID tables / glossary ──
s.seed_submit = "Надіслати"
s.seed_success = "Успішно!"
s.seed_saving = "Збереження..."
s.seed_add = "Додати"
s.seed_bulk_upload_link = "початкові твердження або масове завантаження як csv"
s.seed_for_participants_to_vote = "для голосування учасників:"
s.seed_upload_csv_heading = "Завантажити CSV з початковими твердженнями"
s.seed_csv_format = "Формат CSV:"
s.seed_original_id_uuid = "original_id МАЄ бути UUID."
s.xal_upload_xids = "Завантажити XID"
s.xal_preparing = "Підготовка…"
s.xal_download_csv = "Завантажити CSV"
s.xal_no_xids = "У списку дозволених немає жодного XID для цієї розмови."
s.xal_failed_load = "Не вдалося завантажити список дозволених XID"
s.xal_failed_download = "Не вдалося завантажити CSV"
s.xal_failed_upload = "Не вдалося завантажити XID"
s.xiu_preparing = "Підготовка…"
s.xiu_download_csv = "Завантажити CSV"
s.xiu_votes = "Голоси"
s.xiu_failed_download = "Не вдалося завантажити CSV"
s.xidg_owner_nom = "власник"
s.xidg_conversation_gen = "розмови"
s.xidg_conversation_acc = "розмову"
s.xidg_participants_gen = "учасників"
s.xidg_participants_nom = "учасники"
s.xidg_participant_nom = "учасник"

export default s
